import React from "react";
import { Form, ProgressBar, Button } from "react-bootstrap";
import ReactS3Uploader from "react-s3-uploader";
// import Alert from "react-s-alert";
import { injectIntl } from "react-intl";
import getToken from "../helpers/getToken";

import { UploadIcon } from '../components/svgs'


const FileUpload = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  intl,
  ...props
}) => {
  const [showUpload, setShowUpload] = React.useState(0);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [showFileSizeWarning, setShowFileSizeWarning] = React.useState(false);
  // console.log("showUpload:", showUpload);

  
  return (
    <Form.Group controlId={name}>
      <ReactS3Uploader
        className="inputfile"
        type="file"
        id="picture"
        signingUrl="/s3"
        signingUrlMethod="GET"
        accept={props.accept}
        preprocess={(file, next) => {
          if (props.maxSize && file.size > parseInt(props.maxSize)) {
            // Alert.warning(intl.formatMessage({ id: "error.fileTooBig" }));
            setShowFileSizeWarning(true)
            setTimeout(() => {
              setShowUpload(0); 
              setShowFileSizeWarning(false)
            }, 3000);
          } else {
            // Alert.warning("Uploading Presentation"); 
            // setShowFileSizeWarning(false)
            setShowUpload(1)
            next(file);
          }
        }}
        onProgress={(progress) => {
          if(progress === 0) {
            setShowUpload(progress + 1)
          } else {
            setShowUpload(progress)
          }
        }}
        onError={() => { 
          // Alert.error(
          //   intl.formatMessage({
          //     id: "error.file-upload",
          //   })
          // );
          setShowError(true); 
            setTimeout(() => {
              setShowUpload(0);
              setShowError(false);  
            }, 3000);
         }}
        onFinish={(url) => { 
            setFieldValue(name, url.filename); 
            // Alert.success(
            //   intl.formatMessage({
            //     id: "input.presentation.presentationUploaded"
            //   })
            // );
            setShowSuccess(true);
            setTimeout(() => {
              setShowUpload(0); 
              setShowSuccess(false);
            }, 3000);
          } 
         }
        signingUrlHeaders={{
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getToken()
        }}
        // signingUrlWithCredentials // to pass auth creds via CORS
        uploadRequestHeaders={{
          "x-amz-acl": "public-read"
        }}
        contentDisposition="auto"
        server={process.env.REACT_APP_API_HOST} />
      <label htmlFor="picture">
        {/* <img src="/icons/upload.png" alt="upload" /> */}
        <UploadIcon />
        <span>
          {value ?
            props.buttonUploaded : props.buttonEmpty
          }
        </span>
      </label>
      {
        showUpload !== 0  && <div className="upload-file-progress-container">
        <div className="upload-file-progress">
          <p>{intl.formatMessage({id: "button.uploadingPresentation"})} { (showError || showSuccess || showFileSizeWarning) && <Button onClick={() => setShowUpload(0)} type="button"><img src="/icons/close.png" alt="close" /></Button> }</p>
          <div className="progress-container">
            <ProgressBar now={showUpload} label={`${showUpload}%`} />
            <span className="status-message text-success">{showSuccess && intl.formatMessage({ id: "input.presentation.presentationUploaded" }) }</span>
            <span className="status-message text-danger">{showError && intl.formatMessage({ id: "error.file-upload" }) }</span>
            <span className="status-message text-warning">{showFileSizeWarning && intl.formatMessage({ id: "error.fileTooBig" }) }</span>
          </div>
        </div>
      </div>
      }
      {/* {
        showSuccess && (
          <div className="upload-file-success-container">
            <div className="upload-file-progress">
                <p>Presentation uploaded <Button onClick={() => setShowSuccess(false)} type="button"><img src="/icons/close.png" alt="close" /></Button></p>
            </div>
          </div>
        )
      }
      {
        showError && (
          <div className="upload-file-success-container">
            <div className="upload-file-progress error">
                <p>Error while uploading Presentation <Button onClick={() => setShowError(false)} type="button"><img src="/icons/close.png" alt="close" /></Button></p>
            </div>
          </div>
        )
      }
      {
        showFileSizeWarning && (
          <div className="upload-file-success-container">
            <div className="upload-file-progress warning">
                <p>{intl.formatMessage({ id: "error.fileTooBig" })} <Button onClick={() => setShowFileSizeWarning(false)} type="button"><img src="/icons/close.png" alt="close" /></Button></p>
            </div>
          </div>
        )
      } */}
      {touched[name] && errors[name] ? (
        <Form.Text>{errors[name]}</Form.Text>
      ) : (
          ""
        )}
    </Form.Group>
  );
};

export default injectIntl(FileUpload);
